import request from '@/utils/request'
const route_download_pdf = '/reducer/exportpdf'
const route_download_stp = '/reducer/exportstp'
const route_download_dwg = '/reducer/exportdwg'
const route_download_file_k = '/series/exportk'
const route_download_file_s = '/series/exports'
const route_download_file_px = '/series/exportpx'
const route_download_file_pwzd = '/series/exportpwzd'
const route_download_file_kt = '/series/exportkt'
const route_download_chrome = '/reducer/downloadchrome'
const route_send_mail = '/send/mail'
//发送邮件信息
export function sendEmail(string) {
  const data = {}
  data.msg = string
  return request.post(route_send_mail, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })/* .then((response) => {
    return Promise.resolve(response.data)
  }) */
}

//下载pdf
export function downloadPDF(data){
  console.log(data)
  data.lang = localStorage.getItem('lang');
  var pdfData = route_download_pdf
  + '?reducer_type2='+ encodeURIComponent(data.reducer_type2)
  + '&reducer_type='+ encodeURIComponent(data.reducer_type)
  + '&specifications='+ encodeURIComponent(data.specifications)
  + '&reduction_ratio='+ encodeURIComponent(data.reduction_ratio)
  + '&rated_output_torque='+ encodeURIComponent(data.rated_output_torque)
  + '&fault_stop_torque='+ encodeURIComponent(data.fault_stop_torque)
  + '&max_radial_force='+ encodeURIComponent(data.max_radial_force)
  + '&max_axial_force='+ encodeURIComponent(data.max_axial_force)
  + '&full_load_efficiency='+ encodeURIComponent(data.full_load_efficiency)
  + '&moment_of_inertia='+ encodeURIComponent(data.moment_of_inertia)
  + '&max_speed='+ encodeURIComponent(data.max_speed)
  + '&rated_speed='+ encodeURIComponent(data.rated_speed)
  + '&noise='+ encodeURIComponent(data.noise)
  + '&mass='+ encodeURIComponent(data.mass)
  + '&clearance_precision='+ encodeURIComponent(data.clearance_precision)
  + '&clearance_standard='+ encodeURIComponent(data.clearance_standard)
  + '&torsional_rigidity='+ encodeURIComponent(data.torsional_rigidity)
  + '&lang='+ encodeURIComponent(data.lang)
  + '&is_with_key='+ encodeURIComponent(data.is_with_key)
  window.open(pdfData , '_blank');
}

//下载stp
export function downloadSTP(data){
  //location.href = route_download_stp + '?reducer_type2='+ data.reducer_type2 + '&specifications='+ data.specifications + '&reducer_type='+ data.reducer_type;
  data.lang = localStorage.getItem('lang');
  console.log(data.lang);
  var stpData = route_download_stp
  + '?reducer_type2='+ data.reducer_type2
  + '&specifications='+ data.specifications
  + '&reducer_type='+ data.reducer_type
  + '&lang='+ encodeURIComponent(data.lang)
  window.open(stpData , '_blank');
}
//下载dwg
export function downloadDWG(data){
  data.lang = localStorage.getItem('lang');
  var dwgData = route_download_dwg
  + '?reducer_type2='+ data.reducer_type2
  + '&specifications='+ data.specifications
  + '&reducer_type='+ data.reducer_type
  + '&lang='+ encodeURIComponent(data.lang)
  window.open(dwgData , '_blank');
}

//下载技术参数
export function downloadDetailFile_k(data){
  console.log(data);
  location.href = route_download_file_k + '?reducer_series_name='+ data.name
}

export function downloadDetailFile_s(data){
  console.log(data);
  location.href = route_download_file_s + '?reducer_series_name='+ data.name
}

export function downloadDetailFile_px(data){
  console.log(data);
  location.href = route_download_file_px + '?reducer_series_name='+ data.name
}

export function downloadDetailFile_pwzd(data){
  console.log(data);
  location.href = route_download_file_pwzd + '?reducer_series_name='+ data.name
}

export function downloadDetailFile_kt(data){
  console.log(data);
  location.href = route_download_file_kt + '?reducer_series_name='+ data.name
}

export function downloadChrome(){
  location.href = route_download_chrome
}



// WEBPACK FOOTER //
// ./src/store/electric_download.js